/* eslint-disable @typescript-eslint/explicit-function-return-type */
import axios from "axios";
import { DOMAIN, APRODUCTION,DOMAIN_LIVE } from "./Config";
import { AppId, GetDeviceType, AppVersion } from "./Sign";
import { getAcId, getToken, getUnionId } from "../store/UserStore";
import { Toast } from "antd-mobile";
const CancelToken = axios.CancelToken;
const request = async (uri, { method = "POST", data={}, header= {} }) => {
  const search = new URLSearchParams(window.location.search);
  const timestamp = Date.now();
  let headers = {
    appId: AppId,
    timestamp,
    da_id: await getUnionId(),
    deviceType: GetDeviceType(),
    version: AppVersion,
    "Content-Type": "application/json",
    ...header,
    gh_id: search.get("gh_id") || ``
  };
  const adId = await getAcId();
  const token = await getToken();
  if (adId) headers["ac_id"] = adId;
  if (token) headers["access-token"] = token;
  if (window.cancleList[uri]) {
    window.cancleList[`${uri}`]();
    await new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(1)
      }, 5)
    })
  }
  uri += uri.indexOf("?") > 0 ?`&${search.toString()}` : `?${search.toString()}`;
  let lastUrl=DOMAIN+uri;
  if(uri.indexOf("ive-goods")!=-1){
    lastUrl=DOMAIN_LIVE+uri
  }
  const requestOptions = {
    url: DOMAIN + uri,
    method,
    headers: headers,
    withCredentials: true,
    cancelToken: new CancelToken(c => {
      // 调用c就可以取消此请求
      window.cancleList[uri] = c;
    }),
    validateStatus: (status) => status >= 200 && status <= 401,
  };
  if (method === "POST") {
    requestOptions.data = JSON.stringify(data);
  }
  return axios(requestOptions)
    .then(({ data }) => {
      delete window.cancleList[uri];
      if (data.result === "success") {
        return { data };
      }
      if (data.result === "redirect") {
        window.location.href = data.data;
        return;
      }
      if (data.result === "autherror") {
        const jump = async () => {
          localStorage.removeItem("cjsweiboId");
          const ghId = search.get("gh_id") || 6783801313;
          const code = await getUnionId();
          window.location.replace(
            `${APRODUCTION}/auth/to/weibo?ghId=${ghId}&sys=cjs&code=${code}&redirectUrl=${encodeURIComponent(
              window.location.href
            )}`
          );
        };
        jump();
        return;
      }
      Toast.show(data.message || "请求失败，请重试!");
      return { err: data.message };

    })
    .catch((err) => {
      delete window.cancleList[uri];
      return { err }
    });
};

export default request;

const uploadImg = async (file) => {

  const baseUrl = `https://mlj36.oss-cn-shenzhen.aliyuncs.com`;

  const fileName = `${new Date().getTime()}_${file.name}`;
  const path = `d11/${fileName}`;

  const { data, err } = await axios({
    url: `${DOMAIN}/common/policyOss?dir=d11`,
  })
    .then(({ data, status }) => {
      if (status === 200) {
        return { data: data.data };
      }
      return { err: data };
    })
    .catch((err) => ({ err }));
  if (err) {
    Toast.show("上传失败，请重试");
    return;
  }
  const formData = new FormData();
  formData.append("OSSAccessKeyId", data.accessid);
  formData.append("policy", data.policy);
  formData.append("signature", data.signature);
  formData.append("key", path);
  formData.append("expire", data.expire);
  formData.append("success_action_status", 200);
  formData.append("file", file);

  const options = {
    url: baseUrl,
    method: "POST",
    withCredentials: false,
    data: formData,
    validateStatus: (status) => status >= 200 && status <= 401,
  };
  return axios(options)
    .then(({ data, status }) => {
      if (status === 200) {
        return { data: `${baseUrl}/${path}` };
      }
      Toast.show(data.message || "请求失败，请重试!", 3000);
      return { err: "上传失败" };
    })
    .catch((err) => ({ err }));
};

export { uploadImg };
export const requestApi =async (options)=> {
  return new Promise((resolve, reject) => {
    // 1. 创建一个 new XMLHttpRequest 对象
    var xhr = new XMLHttpRequest();
    if (!options.url) {
      reject("not url pleace check!")
      return
    }
    let url=("https://apipro-h5.qunjielong.com" + options.url)
    xhr.open(options.method || 'GET', url);
    xhr.setRequestHeader("appid", options.data.appId)
    xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');
    xhr.responseType = options.responseType || 'json';
    var data
    if (options.data) {
      if (typeof options.data !== "object") {
        data = options.data
      } else {
        data = JSON.stringify(options.data)
      }
    }
    // 3. 通过网络发送请求
    xhr.send(data);

    // 4. 当接收到响应后，将调用此函数
    xhr.onload = function () {
      if (xhr.status != 200) { // 分析响应的 HTTP 状态
        // alert(`Error ${xhr.status}: ${xhr.statusText}`); // 例如 404: Not Found
        reject(`Error ${xhr.status}: ${xhr.statusText}`)
      } else { // 显示结果
        console.log(`Done, got ${xhr.response.length} bytes`); // response 是服务器响应
        try {
          resolve(xhr.response)
        } catch (error) {
          reject(xhr.response)
        }
      }
    };

    xhr.onerror = function (err) {
      // alert("Request failed");
      reject( err)
    };
  })
}
